import React from 'react'

import './styles.scss'

import { useLogOut } from '../../contexts/AuthContext'

export const TopbarLogoutButton = () => {
  const logOut = useLogOut()

  return (
    <button
      className='topbar-logout-button'
      onClick={logOut}
    >
      Log out
    </button>
  )
}
